import type { FilterDefinition } from "./FilterDefinition";

/**
 * Comparator preset for tag-array fields: membership (`CONTAINS` /
 * `NOT_CONTAINS`) is the only question the backend answers about a tag list.
 * The comparators are the ones `TAG_FIELD_COMPARATORS` in
 * `packages/roboql/src/roboql/model/core.py` puts on every tag field, which
 * the backend enforces before any predicate is generated; `tagFilter.test.ts`
 * fails if this list and the generated RoboQL catalog disagree for any field
 * the preset is applied to.
 *
 * Deliberately not `setComparators` from the filter schema: that list is the
 * vocabulary the SavedFilters model accepts for a `set`-typed filter, pinned
 * to a different manifest by `FilterSchemaParity.test.ts`. The two hold the
 * same operators today but are independent definitions, and only this one
 * decides whether the submitted query is accepted.
 *
 * Spread it into a `string` filter definition so a rename of the key is a
 * compile error rather than a silently dropped restriction:
 *
 *     { type: "string", field: "tags", name: "Tags", ...tagFilter }
 */
export const tagFilter = {
  allowedComparators: ["CONTAINS", "NOT_CONTAINS"],
} as const satisfies Partial<FilterDefinition>;
